import { createFileRoute } from "@tanstack/react-router";
import { KeywordServiceLanding } from "@/components/KeywordServiceLanding";
import { KEYWORD_SERVICE_PAGES, keywordServiceHead } from "@/lib/keywordServicePages";

export const Route = createFileRoute("/nonprofit-website-design-colorado")({
  head: () => keywordServiceHead(KEYWORD_SERVICE_PAGES.nonprofitWeb),
  component: () => <KeywordServiceLanding page={KEYWORD_SERVICE_PAGES.nonprofitWeb} />,
});
